import Item from './Item';
import { getProppingBounds } from '../services/products/models';

export default class ProppingItem extends Item {
  adaptPropping(movingItem, movingSprite) {
    this.draw(movingItem, movingSprite);
  }

  getProppingItem() {
    return this.item;
  }

  getHitArea() {
    const { scaledVertices } = this.data;
    const { ratio, item } = this;
    const padding = 8;

    const proppingItem = this.getProppingItem();

    let proppingHeight = 0;
    if (proppingItem) {
      const bounds = getProppingBounds(proppingItem)[0];
      if (bounds) {
        proppingHeight = bounds.size.height - item.height;
      }
    }

    const vertices = [
      [scaledVertices[0][0], scaledVertices[0][1] + proppingHeight * ratio],
      scaledVertices[7],
      [scaledVertices[6][0] - padding, scaledVertices[6][1]],
      [
        scaledVertices[1][0] - padding,
        scaledVertices[1][1] + proppingHeight * ratio,
      ],
    ];

    const polygon = {
      regions: [vertices],
    };

    return {
      polygon,
    };
  }
}
